export const modalFullscreen = 'fullscreen';
